module.exports = __webpack_public_path__ + "static/media/cu.89e88662.svg";